import React, { Component } from 'react';
import i18n from '../../config/i18n';

class Notice extends Component {
  render() {
    return (
      <div>
        <section className="section section-on-bg">
          <div className="container text-center">
            <h2 className="text-warning">
              {i18n.t('invalidInvitationMsg')}
            </h2>
            <br />
            <p className="lead">
              {i18n.t('needInvitationMsg')}
            </p>
            <p className="lead">
              {i18n.t('plzContactAccManager')}
            </p>
          </div>
        </section>
      </div>
    );
  }
}

export default Notice;



// WEBPACK FOOTER //
// ./src/components/static/Notice.js